export const config = {
    API_URL: "https://api.moowplay.gobeplus.com",
    // API_URL: "http://192.168.1.140:9001",
    API_KEY: "448f57d10bd1bd423db1abdb8f45e556"
}